import { render, staticRenderFns } from "./solutionDetails5.vue?vue&type=template&id=d64cda32&scoped=true&"
import script from "./solutionDetails5.vue?vue&type=script&lang=js&"
export * from "./solutionDetails5.vue?vue&type=script&lang=js&"
import style0 from "./solutionDetails5.vue?vue&type=style&index=0&id=d64cda32&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d64cda32",
  null
  
)

export default component.exports